import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LunkadLogo from "../../assets/lu.png";
import LinkedInLogo from "./../../assets/svg/linkedin.svg";
import MainIcon from "./../../assets/mail-icon.webp";
import NaradBeta from "pages/landing-page/components/LusoftBeta";
import config from "../../config";
import { useNavigate } from "react-router-dom";

export default function Footer(props) {
  const navigate = useNavigate();

  return (
    <>
      <NaradBeta />
      <Box
        sx={{
          px: { xs: 2, sm: 5, md: 10, lg: 23 },
          pt: { xs: 3, md: 6 },
          backgroundColor: (theme) => theme.palette.common.footerBackground,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
            mb: { xs: 3 },
          }}
        >
          <Box
            onClick={() => {
              navigate("/");
            }}
            sx={{ display: { xs: "block" }, cursor: "pointer", flex: 1 }}
          >
            <img
              src={LunkadLogo}
              alt="Lunkad-logo"
              height={"45px"}
              style={{ borderRadius: "10px" }}
            />
          </Box>
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            sx={{ mt: { xs: 2, sm: 0 }, flex: 1 }}
          >
            <Typography
              sx={{
                pr: { xs: 1, md: 2.5 },
                fontSize: "20px",
                fontWeight: 700,
                lineHeight: "32px",
                color: (theme) => theme.palette.common.darkGrey,
              }}
            >
              Reach out to us on
            </Typography>
            <Box
              sx={{
                backgroundColor: "red",
                height: "30px",
                width: "30px",
                borderRadius: "30px",
              }}
            >
              <a
                style={{ display: "inline" }}
                href={`mailto:${config.supportEmail}?subject=Need%20Help%20With%20Application`}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={MainIcon}
                  alt="Email"
                  height="30"
                  width="30"
                  style={{
                    fontSize: "14px",
                    border: 0,
                    outline: "none",
                    textDecoration: "none",
                  }}
                  data-bit="iit"
                />
              </a>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              mt: { xs: 2, sm: 0 },
              flex: 1,
            }}
          >
            <Typography
              sx={{
                pr: { xs: 1, md: 2.5 },
                fontSize: "20px",
                fontWeight: 700,
                lineHeight: "32px",
                color: (theme) => theme.palette.common.darkGrey,
              }}
            >
              Connect with us
            </Typography>
            <a
              href="https://www.linkedin.com/company/lusoft-ai"
              target="_blank"
              rel="noreferrer"
              style={{ display: "flex" }}
            >
              <img src={LinkedInLogo} alt="Lunkad-logo" height={"30px"} />
            </a>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 3,
            pb: 2,
          }}
        >
          <Typography
            sx={{ cursor: "pointer", color: "blue" }}
            onClick={() => navigate("/privacy-policy")}
          >
            Privacy Policy
          </Typography>
          <Typography
            sx={{ cursor: "pointer", color: "blue" }}
            onClick={() => navigate("/terms-of-service")}
          >
            Terms & Conditions
          </Typography>
        </Box>
        <Typography
          sx={{
            textAlign: "center",
            pb: 1,
            fontSize: "16px",
            lineHeight: "24px",
            color: (theme) => theme.palette.common.black,
          }}
        >
          © 2025 Lunkad Infotech All Rights Reserved.
        </Typography>
      </Box>
    </>
  );
}
